// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/css/async/" + chunkId + "." + {"556": "2830b7fb","643": "3996509e","940": "a386a48a",}[chunkId] + ".css"
}